'use client';

import type { FC } from 'react';

import { ModalRootContext } from './context/modal-root.context';
import { useModal } from './hooks/use-modal';
import type { ModalRootPropsInterface } from './types/modal-root.types';

/**
 * @since 10.0.0
 */
export const ModalRoot: FC<ModalRootPropsInterface> = (props: ModalRootPropsInterface) => {
  const { children, scrollDocument = false, size = 'xs', ...rest } = props;
  const modal = useModal(rest);
  return (
    <ModalRootContext.Provider value={{ modal, scrollDocument, size }}>
      {children}
    </ModalRootContext.Provider>
  );
};

ModalRoot.displayName = 'Modal.Root';
